import React, { useState } from 'react';
import { Box, Button, Typography, Paper, Stack } from '@mui/material';
import { FiPlus, FiDownload, FiUpload } from 'react-icons/fi';
import { JournalEntriesTab } from './JournalEntriesTab';
import JournalEntryForm from './forms/JournalEntryForm';
import { CustomDialog } from '../common/CustomDialog';
import { useFiscalSponsor } from '../../hooks/useFiscalSponsor';
import { useAuth } from '../../../hooks/useAuth';
import { JournalEntry } from '../../types/accounting';

interface JournalEntriesProps {
  fiscalSponsorId: string;
}

export const JournalEntries: React.FC<JournalEntriesProps> = ({ fiscalSponsorId }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState<any>(undefined);
  
  // Use the hook to get fiscal sponsor data
  const { fiscalSponsor, loading } = useFiscalSponsor();
  const { user, organization } = useAuth();

  // Add debug logging
  console.log('JournalEntries Debug:', {
    fiscalSponsor,
    fiscalSponsorId,
    organization,
    user,
    loading
  });

  const handleSubmit = async (data: any) => {
    // Handle submission
    console.log('Submitting journal entry:', data);
    
    // Add the fiscalSponsorId to the data before submitting
    const entryWithSponsor = {
      ...data,
      fiscalSponsorId
    };
    
    console.log('Entry with sponsor:', entryWithSponsor);
    
    // Here you would typically call a service to save the data
    // await JournalEntryService.save(entryWithSponsor);
    
    setIsFormOpen(false);
    setSelectedEntry(undefined);
  };

  const handleCancel = () => {
    setIsFormOpen(false);
    setSelectedEntry(undefined);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header Section */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h5">Journal Entries</Typography>
          <Stack direction="row" spacing={2}>
            <Button
              startIcon={<FiUpload />}
              variant="outlined"
              onClick={() => {/* Handle import */}}
            >
              Import Entries
            </Button>
            <Button
              startIcon={<FiDownload />}
              variant="outlined"
              onClick={() => {/* Handle export */}}
            >
              Export Entries
            </Button>
            <Button
              startIcon={<FiPlus />}
              variant="contained"
              onClick={() => setIsFormOpen(true)}
            >
              New Entry
            </Button>
          </Stack>
        </Stack>
      </Paper>

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <JournalEntriesTab 
          onEditEntry={(entry: any) => {
            setSelectedEntry(entry);
            setIsFormOpen(true);
          }}
          onCreateEntry={() => {
            setSelectedEntry(undefined);
            setIsFormOpen(true);
          }}
        />
      </Box>

      {/* Journal Entry Form Dialog */}
      <CustomDialog
        open={isFormOpen}
        onClose={handleCancel}
        maxWidth="lg"
        fullWidth
        title={selectedEntry ? "Edit Journal Entry" : "Create Journal Entry"}
      >
        <JournalEntryForm
          onSubmit={(values: any) => handleSubmit(values)}
          onCancel={handleCancel}
          initialData={selectedEntry as any}
        />
      </CustomDialog>
    </Box>
  );
};

export default JournalEntries; 